import { provideSvgIconsConfig } from '@ngneat/svg-icon';

export const iconProvider = provideSvgIconsConfig({
  sizes: {
    xs: '10px',
    sm: '12px',
    md: '16px',
    lg: '20px',
    xl: '24px',
    xxl: '32px',
    '10': '10px',
    '12': '12px',
    '16': '16px',
    '17': '17px',
    '20': '20px',
    '24': '24px',
    '32': '32px',
    '40': '40px',
    '44': '44px',
    '48': '48px', // TODO change existing sizes to pixel names
    '56': '56px',
    '64': '64px',
    '72': '72px',
  },
  defaultSize: 'lg',
});
